"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCssRenderer = void 0;
const CSS2DRenderer_1 = require("three/examples/jsm/renderers/CSS2DRenderer");
function createCssRenderer(element) {
    const { width, height } = element.getBoundingClientRect();
    const annotationRenderer = new CSS2DRenderer_1.CSS2DRenderer();
    annotationRenderer.setSize(width, height);
    annotationRenderer.domElement.className = 'annotations';
    annotationRenderer.domElement.id = 'annotations';
    return annotationRenderer;
}
exports.createCssRenderer = createCssRenderer;
